import { useTranslation } from "react-i18next";
import i18n from "./config";

export const useApiTranslation = () => {
  const { t } = useTranslation();

  const translateError = (
    errorCode: string,
    defaultMessage?: string,
  ): string => {
    // Convert e.g. ERR_404 to err404 to match translation keys
    const camelCaseCode = errorCode
      .toLowerCase()
      .replace(/_([a-z0-9])/g, (g) => g[1].toUpperCase());

    // API errors are dynamic and cannot be strictly typed via react-i18next.
    // We cast to a known valid key to bypass type-safety issues without casting `any`.
    const keyString = `apiErrors.${camelCaseCode}`;
    const key = keyString as "apiErrors.unknownError";
    const translated = i18n.t(key);

    if (translated !== keyString) {
      return translated;
    }

    return defaultMessage || t("apiErrors.unknownError");
  };

  return { translateError };
};
